import { Route, Routes } from "react-router";
import Login from "../Auth/Login";

const AuthRouter = () => {
    return (
         <Routes>
             <Route path="*" element={<Login />} />
         </Routes>
     );
 }
 
 export default AuthRouter